import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatINR } from "@/lib/format";
import { TrendingUp, Users } from "lucide-react";

export default function Dashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard").then(({ data }) => setData(data)); }, []);
  return (
    <div className="space-y-8" data-testid="dashboard">
      <div>
        <div className="overline">Overview</div>
        <h1 className="font-serif text-4xl mt-1">Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">Live balances across all branches. Updated on every advance, repayment or write-off.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        <Link to="/employees?outstanding=1" className="kpi-card block cursor-pointer hover:border-primary transition-colors group" data-testid="kpi-active-outstanding">
          <div className="flex items-start justify-between">
            <div>
              <div className="overline">Active Outstanding</div>
              <div className="font-serif text-5xl mt-3 tabular-nums" style={{ color: "#C9A876" }}>
                {data ? formatINR(data.active_outstanding) : "—"}
              </div>
              <div className="text-xs text-muted-foreground mt-3">Total advances − total repayments − bad-debt write-offs</div>
              <div className="text-xs gold mt-2 opacity-0 group-hover:opacity-100 transition-opacity">View employees →</div>
            </div>
            <TrendingUp className="w-6 h-6 gold" />
          </div>
        </Link>
        <Link to="/employees?outstanding=1" className="kpi-card block cursor-pointer hover:border-primary transition-colors group" data-testid="kpi-employees-outstanding">
          <div className="flex items-start justify-between">
            <div>
              <div className="overline">Employees with Outstanding</div>
              <div className="font-serif text-5xl mt-3 tabular-nums">{data ? data.employees_with_outstanding : "—"}</div>
              <div className="text-xs text-muted-foreground mt-3">Unique employees with active balance greater than zero</div>
              <div className="text-xs gold mt-2 opacity-0 group-hover:opacity-100 transition-opacity">View employees →</div>
            </div>
            <Users className="w-6 h-6 gold" />
          </div>
        </Link>
      </div>
    </div>
  );
}
